// extracted by mini-css-extract-plugin
export default {"charthead":"downtime_charthead__zFM24","values":"downtime_values__8rUTq","table":"downtime_table__iZw-V","chart":"downtime_chart__4uSKn"};